const state = {
  cur_module_id: "",
  cur_device_id: "",
}

const mutations = {
  SET_CUR_MODULE_ID: (state, id) =>{
    state.cur_module_id = id
  },
  SET_CUR_DEVICE_ID: (state, id) =>{
    state.cur_device_id = id
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/device_lib.js